import { useQuery } from '@tanstack/react-query'

import { getSessionIdFromLocalStorage } from 'src/localStorage/sessionId/getSessionIdFromLocalStorage/getSessionIdFromLocalStorage'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { analyticsApi } from 'src/services/analyticsApi'

export interface TrialStatusData {
  daysRemaining: number
  isExpired: boolean
  isTrial: boolean
  trialEndsAt: string | null
}

interface TrialStatusResponse {
  data: TrialStatusData
  success: boolean
}

// Exported so login can prefetch it before entering the app — see
// src/App/AppRouter/Layout/bannerState.ts.
export const getTrialStatus = async (): Promise<TrialStatusResponse | null> => {
  const sessionId = getSessionIdFromLocalStorage()
  if (!sessionId) return null

  const { data } = await analyticsApi().get<TrialStatusResponse>(
    '/v1_private/user-features/trial-status'
  )
  return data
}

export const useGetTrialStatusQuery = () => {
  const sessionId = getSessionIdFromLocalStorage()

  return useQuery({
    enabled: !!sessionId,
    queryFn: getTrialStatus,
    queryKey: [QueryKey.GET_TRIAL_STATUS],
  })
}
